// const UPLOAD_URL = "https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/"
const UPLOAD_URL = "https://8x1pz40uv9.execute-api.us-east-1.amazonaws.com/dev/uploadfile/"

export const environment = {
  production: false,

  upload: UPLOAD_URL,

  loginUser: "https://d3ywskgc94.execute-api.us-east-1.amazonaws.com/dev/" + "loginUser",
  verifyOtp: "https://d3ywskgc94.execute-api.us-east-1.amazonaws.com/dev/" + "verifyOtp",
  forgotPassword: "https://d3ywskgc94.execute-api.us-east-1.amazonaws.com/dev/" + "forgotPassword",
  resetPassword: "https://d3ywskgc94.execute-api.us-east-1.amazonaws.com/dev/" + "resetPassword",


  getAllCampus: localStorage.getItem('BASE_URL_A') + "getAllCampus",


  // user service starts
  getAllDepartment: localStorage.getItem('BASE_URL_A') + "getAllDepartment",
  getAllRoles: localStorage.getItem('BASE_URL_A') + "getAllRole",
  updateUser: localStorage.getItem('BASE_URL_A') + "updateUser",
  getUser: localStorage.getItem('BASE_URL_A') + "getUser",
  getAllUsers: localStorage.getItem('BASE_URL_A') + "getAllUsers",
  createUser: localStorage.getItem('BASE_URL_A') + "createUser",
  deleteUser: localStorage.getItem('BASE_URL_A') + "deleteUser",
  findAllUsers: localStorage.getItem('BASE_URL_A') + "getAllUserData",
  // user service ends


  // leads service starts
  getLeadsFields: localStorage.getItem('BASE_URL_A') + "getLeadsField",

  // organization service starts
  createOrganization: localStorage.getItem('BASE_URL_A') + 'createOrganization',
  getAllOrgWithCount: localStorage.getItem('BASE_URL_A') + 'getAllOrgWithCount',
  deleteOrganization: localStorage.getItem('BASE_URL_A') + 'deleteOrganization',
  getOrganizationById: localStorage.getItem('BASE_URL_A') + 'getOrgById',
  createCampus: localStorage.getItem('BASE_URL_A') + 'createCampus',
  updateCampus: localStorage.getItem('BASE_URL_A') + 'updateCampus',
  deleteCampus: localStorage.getItem('BASE_URL_A') + 'deleteCampus',
  createDepartment: localStorage.getItem('BASE_URL_A') + 'createDepartment',
  updateDepartment: localStorage.getItem('BASE_URL_A') + 'updateDepartment',
  deleteDepartment: localStorage.getItem('BASE_URL_A') + 'deleteDepartment',
  updateOrganization: localStorage.getItem('BASE_URL_A') + 'updateOrganization',

  // role service starts
  getAllRole: localStorage.getItem('BASE_URL_A') + 'getAllRole',
  createRole: localStorage.getItem('BASE_URL_A') + 'createRole',
  updateRole: localStorage.getItem('BASE_URL_A') + 'updateRole',
  deleteRole: localStorage.getItem('BASE_URL_A') + 'deleteRole',
  // role service ends

  // counter service starts
  getCounterById: localStorage.getItem('BASE_URL_A') + 'getCounterById',
  createCounter: localStorage.getItem('BASE_URL_A') + 'createCounter',
  updateCounter: localStorage.getItem('BASE_URL_A') + 'updateCounter',
  // counter service ends

  // course service starts
  getAllCourses: localStorage.getItem('BASE_URL_B') + 'getAllCourses',
  createCourse: localStorage.getItem('BASE_URL_B') + 'createCourse',

  // course service ends


  // package service starts
  getAllPackages: localStorage.getItem('BASE_URL_A') + 'getAllPackage',
  createPackage: localStorage.getItem('BASE_URL_A') + 'createPackage',
  updatePackage: localStorage.getItem('BASE_URL_A') + 'updatePackage',
  deletePackage: localStorage.getItem('BASE_URL_A') + 'deletePackage',
  // package service ends

  getOrgPackageById: localStorage.getItem('BASE_URL_A') + 'getOrgPackageById',
  createOrgPackage: localStorage.getItem('BASE_URL_A') + 'createOrgPackage',
  updateOrgPackage: localStorage.getItem('BASE_URL_A') + 'updateOrgPackage',


  // organization config service starts
  createOrgConfig: localStorage.getItem('BASE_URL_A') + 'createOrgConfig',
  updateOrgConfig: localStorage.getItem('BASE_URL_A') + 'updateOrgConfig',
  getOrgConfigById: localStorage.getItem('BASE_URL_A') + 'getOrgConfigById',
};


